import clsx from "clsx";
import { NavLink } from "react-router-dom";

interface PositionTabProps {
  to: string;
  label: string;
}

function PositionTab({ to, label }: PositionTabProps): JSX.Element {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        clsx(
          "flex gap-1 items-center font-bold uppercase border-b-2 pb-1",
          isActive ? "border-primary-300" : "border-transparent"
        )
      }
    >
      {({ isActive }) => (
        <>
          <div
            className={clsx(
              isActive ? "text-secondary-700" : "text-neutral-500"
            )}
          >
            {label}
          </div>
        </>
      )}
    </NavLink>
  );
}

export { PositionTab };
